var React = require('react');

function Inspection12 (props) {
    return React.createElement("svg",props,[React.createElement("g",{"id":"12/Inspection","clipPath":"url(#clip0_87_50)","key":0},React.createElement("path",{"id":"Icon","fillRule":"evenodd","clipRule":"evenodd","d":"M12 0L24 8.762V24H18V20C18 20 16 18 12 18C8 18 6 20 6 20V24H0V8.762L12 0ZM16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12Z","fill":"currentColor"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_87_50"},React.createElement("rect",{"width":"12","height":"12","fill":"white","transform":"scale(2)"})))]);
}

Inspection12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 24 24","fill":"none"};

module.exports = Inspection12;

Inspection12.default = Inspection12;
